import { PICTURE_COMPREHENSION_RECOGNITION_MESSAGES } from '../../constants/picture-comprehension.ts';

import { BaseClickHandler } from './base-click-handler.util.ts';

const RADIUS_WIDTH_MULTIPLIER = 0.2;

export class TaskPictureUtil extends BaseClickHandler<React.MouseEvent<HTMLImageElement>, string> {
  private static _instance: TaskPictureUtil;

  public static get instance(): TaskPictureUtil {
    if (!TaskPictureUtil._instance) {
      TaskPictureUtil._instance = new TaskPictureUtil();
    }
    return TaskPictureUtil._instance;
  }

  protected override processInput(input: React.MouseEvent<HTMLImageElement>): string {
    if (!(input.target instanceof HTMLImageElement)) {
      throw new Error('Event target is not an HTMLImageElement');
    }

    const target = input.target;
    const rect = target.getBoundingClientRect();

    const pictureCenter = {
      x: rect.width / 2,
      y: rect.height / 2,
    };
    const radius = rect.width * RADIUS_WIDTH_MULTIPLIER;

    const clickX = input.clientX - rect.left;
    const clickY = input.clientY - rect.top;

    const distance = Math.hypot(clickX - pictureCenter.x, clickY - pictureCenter.y);

    if (distance <= radius) {
      return PICTURE_COMPREHENSION_RECOGNITION_MESSAGES.CORRECT;
    }

    return PICTURE_COMPREHENSION_RECOGNITION_MESSAGES.INCORRECT;
  }
}

export const getTaskPictureUtil = (): TaskPictureUtil => TaskPictureUtil.instance;
